import React, { useState } from "react";
import styles from "./Header2.module.css";

export default function Header2() {
    const [open, setOpen] = useState(false);
    return (
        <header className={styles.header}>
            <div className={styles.wrap}>
                <div className={styles.logo} aria-label="Kids Portal">
                    <div className={styles.badge}>★</div>
                    <div className={styles.brand}>KidsMania</div>
                </div>
            </div>
        </header>
    );
}